import { render } from "./ModalBody.vue?vue&type=template&id=50ccfb3a&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"

import "./ModalBody.vue?vue&type=style&index=0&id=50ccfb3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ccfb3a"],['__file',"src/components/mdbvue/Modals/ModalBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50ccfb3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50ccfb3a', __exports__)) {
    api.reload('50ccfb3a', __exports__)
  }
  
  module.hot.accept("./ModalBody.vue?vue&type=template&id=50ccfb3a&scoped=true", () => {
    api.rerender('50ccfb3a', render)
  })

}


export default __exports__